import {
    CheckCircleOutlined,
    ExclamationCircleOutlined,
    MenuOutlined,
    PlusOutlined,
    UserDeleteOutlined,
    UserOutlined,
} from '@ant-design/icons'
import {
    Alert,
    Button,
    Col,
    Dropdown,
    Input,
    Menu,
    Modal,
    Rate,
    Row,
    Segmented,
    Select,
    Spin,
    Table,
    Tooltip,
    notification,
} from 'antd'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import {
    listOfClientApi,
    listOfUsersApi,
    resendClientVerificationApi,
    updateClientApi,
} from '../../../config/Api'
import { API_ERR_MESSAGE } from '../../../config/constant'
import { apiErrorMessage } from '../../../services/ApiError'
import { FilterApiData } from '../../../services/FilterApiData'
import { setHeaderName } from '../../../services/SetHeaderName'
import { UpdateClientDetail } from './components/UpdateClientDetail'
import './style/ClientsList.scss'
// import { AddPlanPricing } from "./AddPlanPricing";

import { UpgradePlanNotice } from "../../Billing/UpgradePlanNotice";
export const ClientsList = () => {
    const { Option } = Select

    const data = [
        {
            id: '1001',
            name: 'John Brown',
            program: 'Weight Loss',
            email: 'mansi.hbhojani@gmail.com',
            is_email_verified: 0,
            mobile: '097234 49697',
            whatsappNo: '097234 49697',
            durationInDays: 150,
            startDate: '1 June 2022',
            expiresOn: '22 June 2022',
            nutritionist: 'Mansi Bhojani',
            rating: 5,
            phenoType: false,
            status: false,
        },
        {
            id: '1002',
            name: 'Aakash Parekh',
            program: 'Weigh Gain',
            email: 'ap@gmail.com',
            is_email_verified: 1,
            mobile: '097234 55555',
            whatsappNo: '097234 55555',
            durationInDays: 180,
            startDate: '2 July 2022',
            expiresOn: '12 July 2022',
            nutritionist: 'Aakash Parekh',
            rating: 4,
            phenoType: true,
            status: true,
        },
        {
            id: '1003',
            name: 'Darshit Lathigara',
            program: 'Weigh Gain',
            email: 'dl@gmail.com',
            is_email_verified: 0,
            mobile: '45781 49697',
            whatsappNo: '45781 49697',
            durationInDays: 55,
            startDate: '3 Aug 2022',
            expiresOn: '15 Aug 2022',
            nutritionist: 'Darshit Lathigara',
            rating: 4.5,
            phenoType: true,
            status: true,
        },
        {
            id: '1004',
            name: 'Divy Adesara',
            program: 'Weigh Maintain',
            email: 'divy@gmail.com',
            is_email_verified: 1,
            mobile: '55555 49697',
            whatsappNo: '55555 49697',
            durationInDays: 283,
            startDate: '5 Sept 2022',
            expiresOn: '07 Sept 2022',
            nutritionist: 'Milap Parikh',
            rating: 4.2,
            phenoType: false,
            status: false,
        },
        {
            id: '1005',
            name: 'Sagar Parekh',
            program: 'Weigh Gain',
            email: 'sagar@gmail.com',
            is_email_verified: 0,
            mobile: '097234 11111',
            whatsappNo: '097234 11111',
            durationInDays: 100,
            startDate: '1 oct 2022',
            expiresOn: '10 oct 2022',
            nutritionist: 'Bhushan Patadiya',
            rating: 4.7,
            phenoType: true,
            status: true,
        },
    ]

    const [loading, setLoading] = useState(false)
    const [isModalVisible, setIsModalVisible] = useState(false)
    const [isPlanActive, setIsPlanActive] = useState(false)
    const [showErr, setShowErr] = useState(false)
    const [dataSource, setDataSource] = useState([])
    const [displayData, setDisplayData] = useState([])
    // the table's page, so the # column keeps counting across pages
    const [page, setPage] = useState({ current: 1, pageSize: 10 })
    const [value, setValue] = useState('')
    const [clientData, setClientData] = useState()
    const [activeClientFilter, setActiveClientFilter] = useState()

    const [editPatientRecord, setEditPatientRecord] = useState()
    const [buttonName, setButtonName] = useState('ADD')
    const [userRole, setUserRole] = useState()

    const [patientData, setPatientData] = useState()
    const [totalActiveClientLimit, setTotalActiveClientLimit] = useState()

    // get the list of all nutritionist data to get user plan and active client limit
    //=================================
    const getListOfUsers = () => {
        listOfUsersApi()
            .then((res) => {
                if (res.status === 200) {
                    const nutritionistData = FilterApiData(res.data.data)
                    if (nutritionistData.length > 0) {
                        let userId = localStorage.getItem('id')
                        // get the login user data by its userid
                        const loginUserData = nutritionistData.find(
                            (element) => element.id == userId
                        )
                        // console.log("total patient limit of user plan", loginUserData?.plan?.active_clients);
                        setTotalActiveClientLimit(
                            loginUserData?.plan?.active_clients
                        )
                    }
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    // Resend Verification Email
    //==============================
    const resendVerificationEmail = (record) => {
        resendClientVerificationApi(record.id)
            .then((res) => notification.success({ message: res.data.message }))
            .catch((err) => notification.error({ message: apiErrorMessage(err) }))
    }

    const verifyMobile = (data) => {
        const updatedData = {
            ...data,
            is_mobile_verified: 1,
        }
        updateClientApi(data.id, updatedData)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: 'Mobile verified successfully',
                    })
                    getListOfPatient()
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    // get List of Patient List
    //==============================
    const getListOfPatient = () => {
        setLoading(true)

        listOfClientApi()
            .then((res) => {
                if (res.status === 200) {
                    // set data of those users whose status is ACTIVE
                    if (res?.data?.data) {
                        if (res?.data?.data?.length > 0) {
                            setDisplayData(FilterApiData(res.data.data))
                            setDataSource(res.data.data)
                            // console.log(FilterApiData(res.data.data).length);
                        }
                    }
                }
                setLoading(false)
            })
            .catch((err) => {
                // console.log("err--", err);
                setLoading(false)
                notification.error({
                    message: API_ERR_MESSAGE,
                })
            })
    }

    useEffect(() => {
        const roleData = JSON.parse(localStorage.getItem('user'))
        setUserRole(roleData?.user?.role)
        setHeaderName('Clients List')
        getListOfPatient()
        getListOfUsers()
    }, [])

    useEffect(() => {
        if (isModalVisible) {
            setTimeout(() => {
                setClientData(clientData)
            }, 2000)
        }
    }, [clientData])

    // active and deactive client filter
    //==============================
    const clientFilter = (value) => {
        const FilterClientData = dataSource.filter((element) => {
            return element.status == value
        })
        setDisplayData(FilterClientData)
        setActiveClientFilter(value)
    }

    const handleCancel = () => {
        setIsModalVisible(false)
    }

    // update status of Patient List
    //==============================
    const updatePatientDetail = (checked, data) => {
        // let updatedData = data;
        // console.log(totalActiveClientLimit);
        // console.log(FilterApiData(dataSource).length);
        // console.log(checked);

        // at the time when user click on activate button check active client length and plan active client limit then render api
        if (
            checked &&
            FilterApiData(dataSource).length >= totalActiveClientLimit
        ) {
            // console.log("limit exceed");
            setShowErr(true)
        } else {
            const updatedData = {
                name: data.name,
                email: data.email,
                // "password": data.password,
                mobile: data.mobile,
                whatsapp_number: data.whatsapp_number,
                program_id: data.program_id,
                start_date: data.start_date,
                end_date: data.end_date,
                status: checked,
                phenotype_status: data.phenoType,
            }
            updatedData.status = checked

            updateClientApi(data.id, updatedData)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: 'Patient Update successfully',
                        })
                        // call patient list to get an updated data
                        getListOfPatient()
                        setActiveClientFilter(true)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    })
                })
        }
    }

    const columns = [
        {
            // position in the list as shown (after search, filters and sorting); the ID stays internal
            title: '#',
            key: 'index',
            render: (_, __, index) => (page.current - 1) * page.pageSize + index + 1,
        },
        {
            title: 'Name',
            dataIndex: ['name', 'id'],
            key: 'name',
            sorter: (a, b) => a.name.localeCompare(b.name),
            render: (text, record) => (
                <Link to={{ pathname: `/patient-detail/${record.id}` }}>
                    {record.name}
                </Link>
            ),
        },
        {
            title: 'Email',
            dataIndex: 'email',
            key: 'email',
            render: (text, record) => (
                <>
                    {record.email}
                    {record.is_email_verified == 1 ||
                    record.is_email_verified == true ? (
                        <Tooltip title="Email is Verified">
                            <CheckCircleOutlined
                                className="ms-2"
                                style={{ color: 'green' }}
                            />
                        </Tooltip>
                    ) : (
                        <Tooltip title="Email is not Verified">
                            <ExclamationCircleOutlined
                                className="ms-2"
                                style={{ color: 'red' }}
                            />
                        </Tooltip>
                    )}
                </>
            ),
        },
        {
            title: 'Mobile',
            dataIndex: 'mobile',
            key: 'mobile',
        },
        {
            title: 'Program',
            dataIndex: 'program',
            key: 'program',
            render: (text, data) => <p className="mb-0">{text?.name}</p>,
        },
        // {
        //     title: 'Duration (In Days)',
        //     dataIndex: 'durationInDays',
        //     key: 'durationInDays',
        //     defaultSortOrder: 'ascend',
        //     sorter: (a, b) => a.durationInDays - b.durationInDays,
        // },
        {
            title: 'Start Date',
            dataIndex: 'start_date',
            key: 'start_date',
            defaultSortOrder: 'ascend',
            // render: (text, data) => <p className="mb-0">{text?.split('T')[0]}</p>
        },
        {
            title: 'End Date',
            dataIndex: 'end_date',
            key: 'end_date',
            defaultSortOrder: 'ascend',
            // sorter: (a, b) => a.expiresOn - b.expiresOn,
            render: (text, data) => (
                <p className="mb-0">{text?.split('T')[0]}</p>
            ),
        },
        {
            title: 'Nutritionist',
            dataIndex: 'user',
            key: 'nutritionist',
            className: userRole !== 'Admin' && 'd-none',
            render: (text, data) => <p className="mb-0">{text?.name}</p>,
        },
        {
            title: 'Rating',
            dataIndex: 'rating',
            key: 'rating',
            // no default sort here: the list stays oldest client first (it used to sort by ID first)
            sorter: (a, b) => a.rating - b.rating,
            render: (text, record) => (
                <>
                    <Rate disabled allowHalf value={record.rating} />
                </>
            ),
        },
        {
            title: 'PhenoType',
            dataIndex: 'phenotype_status',
            key: 'phenoType',
            render: (text, data) => (
                <>
                    {/* <Switch checked={text} onChange={(e) => { setIsActive(!isActive); onChange(e, data) }} /> */}
                    <p
                        style={{
                            color: data.phenotype_status ? 'green' : 'red',
                        }}
                    >
                        {data.phenotype_status ? 'Enabled' : 'Disabled'}{' '}
                    </p>
                </>
            ),
            filters: [
                { text: 'Enabled', value: true },
                { text: 'Disabled', value: false },
            ],
            onFilter: (value, record) => record.phenotype_status == value,
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text, data) => (
                <>
                    <p style={{ color: data.status ? 'green' : 'red' }}>
                        {data.status ? 'Active' : 'Deactivated'}{' '}
                    </p>
                </>
            ),
            filters: [
                { text: 'Activate', value: true },
                { text: 'Deactivated', value: false },
            ],
            onFilter: (value, record) => record.status == value,
        },
        {
            title: 'Whatsapp No',
            dataIndex: 'whatsapp_number',
            key: 'whatsappNo',
        },
        {
            title: 'Action',
            key: 'action',
            render: (text, record) => (
                <div className="action align-self-center">
                    <Dropdown
                        className="w-100"
                        overlay={
                            <Menu className="w-100" style={{ minWidth: 220 }}>
                                <Menu.Item
                                    key="edit"
                                    // onClick={() => { setClientData(record); setIsModalVisible(true) }}
                                    onClick={(e) => editPatientData(record)}
                                >
                                    {/* <EditOutlined className="me-2" /> */}
                                    Edit
                                </Menu.Item>
                                {!record.status ? (
                                    <Menu.Item
                                        key="activate"
                                        onClick={() =>
                                            updatePatientDetail(true, record)
                                        }
                                    >
                                        {/* <MinusCircleOutlined className="me-2" /> */}
                                        Activate
                                    </Menu.Item>
                                ) : (
                                    <Menu.Item
                                        key="deactivate"
                                        onClick={() =>
                                            updatePatientDetail(false, record)
                                        }
                                    >
                                        {/* <MinusCircleOutlined className="me-2" /> */}
                                        Deactivate
                                    </Menu.Item>
                                )}
                                {!record.is_email_verified && (
                                    <>
                                        {/* {!record.is_mobile_verified && (
                                            <Menu.Item
                                                key="verify_mobile"
                                                onClick={() =>
                                                    verifyMobile(record)
                                                }
                                            >
                                                Verify Mobile
                                            </Menu.Item>
                                        )} */}
                                        <Menu.Item
                                            key="resend"
                                            onClick={() =>
                                                resendVerificationEmail(record)
                                            }
                                        >
                                            {/* <MinusCircleOutlined className="me-2" /> */}
                                            Resend Verification Email
                                        </Menu.Item>
                                    </>
                                )}
                            </Menu>
                        }
                        placement="bottom"
                        arrow={{ pointAtCenter: true }}
                    >
                        <Button icon={<MenuOutlined />} className="me-2" />
                    </Dropdown>
                </div>
            ),
        },
    ]

    // filter Patient List
    //==============================
    const filterPatient = (data) => {
        setPage((current) => ({ ...current, current: 1 }))
        if (!data) {
            setDisplayData(dataSource)
        } else {
            let tmp = []
            dataSource.length > 0 &&
                dataSource.forEach((element) => {
                    if (
                        element?.name
                            ?.toUpperCase()
                            .indexOf(data.toUpperCase()) !== -1 ||
                        element?.program?.name
                            .toUpperCase()
                            .indexOf(data.toUpperCase()) !== -1 ||
                        element?.email
                            .toUpperCase()
                            .indexOf(data.toUpperCase()) !== -1
                    ) {
                        tmp.push(element)
                    }
                })
            setDisplayData(tmp)
        }
    }

    // filter data
    const filterUserRoles = (userData) => {
        let filteredList = data.filter((freight) =>
            Object.keys(freight).some(
                (key) =>
                    freight[key]
                        .toLowerCase()
                        .indexOf(data.name.toLowerCase()) !== -1
            )
        )
        const result = data.includes(userData)
    }

    const editPatientData = (data) => {
        setButtonName('UPDATE')
        setEditPatientRecord(data)
        setIsModalVisible(true)
    }

    return (
        <>
            <div className="ClientsList">
                <UpgradePlanNotice />
                <Row gutter={[8, 8]} className="mb-2">
                    {/* <Col xl={2} className="align-self-center">
                        <Link to={{ pathname: '/add-user' }} >
                            <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 " icon={<PlusOutlined style={{ fontSize: "1.2rem" }} />} onClick={() => setIsModalVisible(true)}>
                                Add Patient
                            </Button>
                        </Link>
                    </Col> */}
                    <Col
                        xs={24}
                        sm={12}
                        md={9}
                        lg={6}
                        xl={6}
                        xxl={6}
                        className="align-self-center"
                    >
                        {/* <Button htmlType="submit" className="submit-button  border-0 rounded ms-2 " onClick={() => setIsModalVisible(true)}>
                            Add
                        </Button> */}
                        <Segmented
                            defaultChecked="active_client"
                            value={activeClientFilter}
                            onChange={clientFilter}
                            options={[
                                {
                                    label: 'Active Clients',
                                    value: true,
                                    icon: <UserOutlined />,
                                },
                                {
                                    label: 'Deactive Clients',
                                    value: false,
                                    icon: <UserDeleteOutlined />,
                                },
                            ]}
                        />
                    </Col>

                    <Col
                        xs={6}
                        sm={12}
                        md={6}
                        lg={4}
                        xl={3}
                        xxl={3}
                        className="align-self-center"
                    >
                        <Button
                            htmlType="submit"
                            icon={<PlusOutlined />}
                            onClick={() => {
                                setButtonName('Add')
                                setIsModalVisible(true)
                            }}
                            className="submit-button  rounded ms-3"
                        >
                            ADD
                        </Button>
                    </Col>
                    <Col xs={18} sm={18} md={8} lg={4} xl={6} xxl={6}>
                        {showErr && (
                            <Alert
                                onClose={() => setShowErr(false)}
                                message="Your Active Client limit exceed"
                                type="warning"
                                showIcon
                                closable
                            />
                        )}
                    </Col>
                    <Col
                        xs={24}
                        sm={6}
                        md={5}
                        lg={4}
                        xl={4}
                        xxl={4}
                        className="text-end align-self-center pe-4"
                    >
                        <h6 className="mb-0">
                            Total Users:{' '}
                            {displayData && displayData?.length > 0
                                ? displayData?.length
                                : 0}{' '}
                        </h6>
                    </Col>

                    <Col
                        xs={24}
                        sm={18}
                        md={8}
                        lg={4}
                        xl={5}
                        xxl={5}
                        className="align-self-center pe-2"
                    >
                        <Input.Search
                            placeholder="Search Users"
                            // onChange={e => {
                            //     let currValue = e.target.value;
                            //     setValue(currValue);
                            //     let filteredData = data.filter(entry =>
                            //         entry.name.toLowerCase().includes(currValue) ||
                            //         entry.durationInDays.toString().includes(currValue) ||
                            //         entry.startDate.toString().includes(currValue) ||
                            //         entry.expiresOn.toString().includes(currValue) ||
                            //         entry.email.toLowerCase().includes(currValue) ||
                            //         entry.program.toString().includes(currValue) ||
                            //         entry.nutritionist.toLowerCase().includes(currValue) ||
                            //         entry.expiresOn.toLowerCase().includes(currValue));
                            //     setDataSource(filteredData);
                            // }}
                            onChange={(e) => {
                                filterPatient(e.target.value)
                                setPatientData(e.target.value)
                            }}
                            className="p-2"
                        />
                    </Col>
                </Row>
                <Spin spinning={loading} className="spinner-code">
                    <Row>
                        <Col span={24}>
                            <Table
                                columns={columns}
                                // oldest client first, as when the list was sorted by ID
                                dataSource={[...displayData].sort((a, b) => a.id - b.id)}
                                rowKey="id"
                                pagination={{ current: page.current, pageSize: page.pageSize }}
                                onChange={(pagination) => setPage({ current: pagination.current, pageSize: pagination.pageSize })}
                                // pagination={false}
                                scroll={{ x: 'max-content' }}
                                className="w-100"
                            />
                        </Col>
                    </Row>
                </Spin>
            </div>

            <Modal
                open={isModalVisible}
                // centered
                footer={null}
                width={800}
                className="UpdateClientDetail rounded"
                onCancel={handleCancel}
            >
                <UpdateClientDetail
                    //  clientData={clientData}
                    getListOfPatient={getListOfPatient}
                    editPatientRecord={editPatientRecord}
                    setIsModalVisible={setIsModalVisible}
                    setButtonName={setButtonName}
                    buttonName={buttonName}
                />
            </Modal>
        </>
    )
}
